var _style, _path, _path2, _path3, _path4, _path5, _path6, _path7, _circle, _circle2, _circle3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcCreditCentral(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 256 256",
    style: {
      enableBackground: "new 0 0 256 256"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n\t.st1{fill:none;stroke:#FFFFFF;stroke-width:1.26;stroke-miterlimit:10;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M203,213.9c-23.3,0-66.9-30.1-102.7-66c-10-10-19.3-20.2-27.6-30.5C40.4,78,27,45,38.5,33.6 C54.9,17.1,109.6,52,152.9,95.3c43.3,43.3,78.3,98,61.8,114.4C211.9,212.6,207.9,213.9,203,213.9z M50.2,33.8 c-3.8,0-6.7,0.9-8.6,2.8c-9.5,9.5,4.7,41.6,34.5,78c8.3,10.1,17.5,20.3,27.3,30.1c50.8,50.8,97,73,108.2,61.8 c5.8-5.8,2.8-20.4-8.2-40.2c-11.6-20.8-30.6-45-53.6-68C107.6,56.3,68.6,33.8,50.2,33.8z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M109.7,78.3"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M120.1,69.4"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M55.7,214c-6.8,0-12.2-1.8-16-5.6c-8.7-8.7-7.4-25.9,3.7-48.7c10.7-22,29.3-46.9,52.4-69.9 c4.5-4.5,9.2-9,13.9-13.2l3,3.3c-4.6,4.2-9.3,8.5-13.7,13c-22.7,22.7-41,47.1-51.5,68.7c-10,20.6-11.6,36.5-4.5,43.6 c12.2,12.2,49.4-2.1,88.3-34.1l2.8,3.4C103,199.9,74.4,214,55.7,214z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M144.7,164l-3-3.3c4.1-3.7,8.1-7.5,12-11.5c45.6-45.6,71.3-97.1,56-112.3c-12.2-12.2-49.4,2.1-88.3,34.2 l-2.8-3.4c42-34.6,79.9-48.2,94.2-33.9c17.5,17.5-7.1,69.6-56,118.6C152.9,156.3,148.8,160.2,144.7,164z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M203,213.9c-23.3,0-66.9-30.1-102.7-66l3.1-3.1c50.8,50.8,97,73,108.2,61.8l3.1,3.1 C211.9,212.6,207.9,213.9,203,213.9z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M149.8,98.5c-50.8-50.8-97-73-108.2-61.8l-3.1-3.1C54.9,17.1,109.6,52,152.9,95.3L149.8,98.5z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 146.9,
    cy: 158.5,
    r: 8.9
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 49.8,
    cy: 82.2,
    r: 6.6
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 174.8,
    cy: 37,
    r: 6.6
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcCreditCentral);
export default __webpack_public_path__ + "static/media/ic-credit-central.fb42284d481ab4e0f88e71f0f82b1d31.svg";
export { ForwardRef as ReactComponent };